import { useNavigate } from 'react-router-dom';

import { ErrorState } from '@/components/common/ErrorState';
import { Layout } from '@/components/Layout';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Layout>
      <ErrorState
        heading="404"
        message="Page not found"
        onPrimaryAction={() => void navigate('/')}
        primaryActionLabel="Back to home"
        testId="not-found"
      />
    </Layout>
  );
}
